import { useState } from 'react';
import { Tabs } from '@/components/ui/tabs';
import { LeaveTypesMergedSection } from './LeaveTypesMergedSection';
import { LeaveApprovalFlowSection } from './LeaveApprovalFlowSection';
import { LeaveCreditSection } from './LeaveCreditSection';
import { LeaveBlockedDatesSection } from './LeaveBlockedDatesSection';

const SUB_TABS = [
  { key: 'leave_types',   label: 'Leave Types' },
  { key: 'approval_flow', label: 'Approval Flow' },
  { key: 'credits',       label: 'Credits' },
  { key: 'blocked_dates', label: 'Blocked Dates' },
] as const;

type SubTab = typeof SUB_TABS[number]['key'];

export function LeaveConfigSection() {
  const [active, setActive] = useState<SubTab>('leave_types');

  return (
    <div className="space-y-4">
      <Tabs
        tabs={SUB_TABS.map((t) => ({ key: t.key, label: t.label }))}
        active={active}
        onChange={(k) => setActive(k as SubTab)}
      />
      {active === 'leave_types'   && <LeaveTypesMergedSection />}
      {active === 'approval_flow' && <LeaveApprovalFlowSection />}
      {active === 'credits'       && <LeaveCreditSection />}
      {active === 'blocked_dates' && <LeaveBlockedDatesSection />}
    </div>
  );
}
